<template>
  <div id="app">
    <Quiz></Quiz>
  </div>
</template>

<script>
import Quiz from "./components/Quiz";

export default {
  name: "app",
  components: {
    Quiz
  }
};
</script>

<style lang="scss">
@import "./assets/fonts/stylesheet.css";

#app {
  font-family: "F Grotesk Demi CYR";
}
  body{
    margin: 0;
  }
</style>
